module.exports = __webpack_public_path__ + "img/3 Innenaufnahme HSV.cb4aab70.jpg";